import {ApiComm} from "../comm";
import {ResponseDTO} from "../dto/ResponseDTO";
import { NoobookFileInfoDTO } from "../dto/CommonDTOs";
import {genNoobookHeader} from "./Common";
import _ from "lodash";
import { NbmessageDTO, NbmessageInputReqDTO } from "../dto/MessageDTOs";



export function uploadMessageFileToTempFile(authToken:string, file:File):Promise<ResponseDTO<NoobookFileInfoDTO>>
{
    return ApiComm.postFormData<ResponseDTO<NoobookFileInfoDTO>>(`/close/v1/message/file`
        , {file:file}
        , genNoobookHeader(authToken, null, 'multipart/form-data', "app")
    ).then(resp=>resp.data);
}




export function searchRecvMessages(authToken:string, keyword:string, page:number, size:number):Promise<ResponseDTO<NbmessageDTO[]>>
{
    return ApiComm.getData<ResponseDTO<NbmessageDTO[]>>(`/close/v1/message/search/recv`
        , {senderId:null, keyword:keyword, page:page, size:size}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function searchSentMessages(authToken:string, keyword:string, page:number, size:number):Promise<ResponseDTO<NbmessageDTO[]>>
{
    return ApiComm.getData<ResponseDTO<NbmessageDTO[]>>(`/close/v1/message/search/sent`
        , {senderId:null, keyword:keyword, page:page, size:size}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}



export function sendDirectMessage(authToken:string, reqDto:NbmessageInputReqDTO):Promise<ResponseDTO<NbmessageDTO>>
{
    return ApiComm.postData<ResponseDTO<NbmessageDTO>>(`/close/v1/message`
        , reqDto
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}




export function modifyDirectMessage(authToken:string, messageId:number, reqDto:NbmessageInputReqDTO):Promise<ResponseDTO<NbmessageDTO>>
{
    return ApiComm.putData<ResponseDTO<NbmessageDTO>>(`/close/v1/message/${messageId}`
        , reqDto
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}



export function deleteMessage(authToken:string, messageId:number):Promise<ResponseDTO<NbmessageDTO>>
{
    return ApiComm.deleteData<ResponseDTO<NbmessageDTO>>(`/close/v1/message/${messageId}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function markMessageRead(authToken:string, messageId:number):Promise<ResponseDTO<void>>
{
    return ApiComm.putData<ResponseDTO<void>>(`/close/v1/message/${messageId}/read`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function getMessage(authToken:string, messageId:number):Promise<ResponseDTO<NbmessageDTO>>
{
    return ApiComm.getData<ResponseDTO<NbmessageDTO>>(`/close/v1/message/${messageId}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function sendBrMessage(authToken:string, reqDto:NbmessageInputReqDTO):Promise<ResponseDTO<NbmessageDTO>>
{
    return ApiComm.postData<ResponseDTO<NbmessageDTO>>(`/close/v1/admin/message/broadcast`
        , reqDto
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}




export function searchChatMessages(authToken:string, othersId:number, keyword:string, page:number, size:number):Promise<ResponseDTO<NbmessageDTO[]>>
{
    return ApiComm.getData<ResponseDTO<NbmessageDTO[]>>(`/close/v1/message/search/chat`
        , {othersId:othersId, keyword:keyword, page:page, size:size}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function getUnreadMessageCount(authToken:string):Promise<ResponseDTO<number>>
{
    return ApiComm.getData<ResponseDTO<number>>(`/close/v1/message/unread/count`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}